
import { defineComponent } from "vue";
import { Notification } from "@/types";
import { uuid } from "vue-uuid";

export default defineComponent({
  name: "NotificationsDropdown",
  data() {
    return {
      windowWidth: window.innerWidth,
      notifications: [
        {
          notificationId: uuid.v1(),
          senderId: uuid.v1(),
          senderName: "Cebu Food Bank",
          type: "Notification",
          message: "has accepted your donation reception.",
          createdAt: new Date().toDateString(),
          read: false,
        },
        {
          notificationId: uuid.v1(),
          senderId: uuid.v1(),
          senderName: "Anonymous",
          type: "Report",
          message: "has reported you.",
          createdAt: new Date().toDateString(),
          read: false,
          report: {
            reportId: uuid.v1(),
            reportType: "Other",
            anonymous: true,
            resolved: false,
          },
        },
        {
          notificationId: uuid.v1(),
          senderId: uuid.v1(),
          senderName: "JPIC-IDC Inc.",
          type: "Notification",
          message: "successfully received your donation.",
          createdAt: new Date().toDateString(),
          read: true,
        },
        {
          notificationId: uuid.v1(),
          senderId: uuid.v1(),
          senderName: "Hippodromo Barangay Hall",
          type: "Notification",
          message: "successfully received your donation.",
          createdAt: new Date().toDateString(),
          read: true,
        },
      ] as unknown as Notification[],
      filteredNotifications: [] as Notification[],
    };
  },
  props: {
    filterByRead: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onResize(): void {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.filteredNotifications = Object.assign([], this.notifications);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    filterByRead: function (data): void {
      if (data) {
        this.filteredNotifications = this.notifications.filter(
          (item: Notification) => item.read === false
        );
      } else {
        this.filteredNotifications = Object.assign([], this.notifications);
      }
    },
  },
});
